import { render } from "./DomainSelector.vue?vue&type=template&id=524317aa"
import script from "./DomainSelector.vue?vue&type=script&lang=js"
export * from "./DomainSelector.vue?vue&type=script&lang=js"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__